import { Injectable } from '@angular/core';

@Injectable()
export class StateService {
  email: string;
  errors: string[] = [];
  loading: boolean = false;
}